// extracted by mini-css-extract-plugin
export default {"MasterBoxNoticias":"noticias_MasterBoxNoticias__dfBq5","Banner":"noticias_Banner__0oYEM","overlay":"noticias_overlay__L1P0m"};